"use client";

import { useEffect } from "react";

export function SwRegister() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!("serviceWorker" in navigator)) return;
    if (process.env.NODE_ENV !== "production") return;

    const onLoad = () => {
      const hadController = Boolean(navigator.serviceWorker.controller);
      let refreshing = false;

      // Cuando ya hay una versión controlando la página, un cambio de
      // service worker significa que hay una versión nueva desplegada.
      // Recargamos una sola vez cuando el nuevo worker toma el control.
      if (hadController) {
        navigator.serviceWorker.addEventListener("controllerchange", () => {
          if (refreshing) return;
          refreshing = true;
          window.location.reload();
        });
      }

      navigator.serviceWorker
        .register("/sw.js", { updateViaCache: "none" })
        .then((registration) => registration.update())
        .catch((err) => {
          console.warn("[sw] update failed:", err);
        });
    };

    if (document.readyState === "complete") {
      onLoad();
    } else {
      window.addEventListener("load", onLoad, { once: true });
    }
  }, []);

  return null;
}
